export enum UserType {
    Requester = 0, Attendant = 1
}

export enum CommentType {
    Internal = 0, External = 1, Work = 2, Pattern = 3
}

export interface SolicitationComment {
    id?: number;
    idSolicitation?: number;
    commentType?: CommentType;
    commentDate?: Date;
    idUser?: number;
    userName?: string | null;
    text?: string;
    disabled?: boolean;
    idWork?: number | null;
    userType?: UserType;
    idContactType?: number;
    sent?: boolean;
    templateId?: number;
    cryptTag?: string;
    externalEmails?: string[];
}
export interface DomainEmailsResult {
    IdSolicitation: number;
    Domain: string;
    Result: boolean;
}